"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vasat = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const types_1 = require("./models/types");
const base_models_1 = require("./models/base-models");
const user_1 = require("./models/user");
const device_1 = require("./models/device");
class Vasat {
    constructor(config, storage, UserModel) {
        this.config = config;
        this.storage = storage;
        this.UserModel = UserModel;
        this.pathPrefix = "/api";
        // Events
        this._logoutEvent = new rxjs_1.Subject();
        this.onLogout = this._logoutEvent.asObservable().pipe((0, operators_1.share)());
        this._errorEvent = new rxjs_1.Subject();
        this.onErrorEvent = this._errorEvent.asObservable().pipe((0, operators_1.share)());
        this._modelCache = {};
        this._cacheClass = {};
        this._modelCacheHash = {};
        this._persistSession = true;
        this.services = [];
        this.servicesLoading = null;
        this._modelPrefixes = {};
        this._refreshing = null;
        this._refreshingObs = null;
        this._defaultDeviceMeta = new device_1.BrowserDeviceMeta();
        // check if storage is null or is not injected so we use the default one
        if (!this.storage) {
            this.storage = new types_1.VasatStorage();
        }
        // Check if the UserModel (user class implementation) is not provided and use the default one.
        if (!this.UserModel) {
            this.UserModel = user_1.UserRow;
        }
        this._sessionSubject = new rxjs_1.BehaviorSubject(null);
        this._sessionObservable = this._sessionSubject.asObservable().pipe((0, operators_1.map)((a) => {
            if (a instanceof types_1.VasatError) {
                throw a;
            }
            return a;
        }));
        let s = this.localSession();
        if (config.debug) {
            let session = "\n\nsession\t\t= Nil\n";
            if (s) {
                let expr = "Nil";
                let exp = s.expires_by;
                if (exp) {
                    exp = (s.expires_by - new Date().getTime()) / 6000;
                    let unit = 'mins';
                    if (exp > 100) {
                        exp = exp / 60;
                        unit = 'hrs';
                    }
                }
                session = '\n\nsession \t= ' + s.access_token +
                    '\nexpires \t= ' + expr +
                    '\nuser \t\t= ' + (s.user ? s.user.name + ' [' + s.user.id + ']' : 'Nil') + '\n';
            }
            console.log('#### Vasat Instance ####\n' +
                '\nhost \t\t= ' + this.config.host +
                '\nclient \t\t= ' + this.config.clientId + session);
        }
    }
    clientKey() {
        return 'v2_' + this.config.clientId + "_" + this.config.host.replace(/[\/\:\.\-]+/g, '_');
    }
    registerCacheClass(obj, items, overrideExisting) {
        let key = null;
        if ((typeof obj) == 'string')
            key = obj;
        else {
            key = this.classNameForType(obj);
        }
        if (!this._cacheClass[key] && (typeof obj) != 'string')
            this.registerClass(obj);
        if (!this._modelCache[key] || overrideExisting) {
            this._modelCache[key] = [];
            this._modelCacheHash[key] = {};
        }
        let curCache = this._modelCache[key];
        let curCacheHash = this._modelCacheHash[key];
        items.forEach(i => {
            // just blindly push
            if (overrideExisting) {
                curCache.push(i);
                if (i.id)
                    curCacheHash['_' + i.id] = i;
            }
            else {
                if (i.id && curCacheHash['_' + i.id])
                    curCacheHash['_' + i.id].set(i.toJSON());
                else {
                    curCache.push(i);
                    if (i.id)
                        curCacheHash['_' + i.id] = i;
                }
            }
        });
    }
    registerPathPrefix(m, prefix) {
        var t = new m(this);
        this._modelPrefixes[t.domainName() ? t.domainName() + '/' + t.className() : t.className()] = prefix;
    }
    modelPathPrefix(m) {
        return this._modelPrefixes[m.domainName() ? m.domainName() + '/' + m.className() : m.className()] || this.pathPrefix;
    }
    classNameForType(obj) {
        var t = new obj(this);
        return t.className();
    }
    registerClass(obj) {
        let key = this.classNameForType(obj);
        if (!this._cacheClass[key])
            this._cacheClass[key] = obj;
    }
    findCached(obj, id) {
        let key = (typeof obj) == 'string' ? obj : this.classNameForType(obj);
        if (this._modelCache[key] && (typeof id == 'number' || typeof id == 'string'))
            return this._modelCacheHash[key]['_' + id];
        else if (this._modelCache[key] && typeof id == 'function')
            return this._modelCache[key].find(o => id(o));
        return null;
    }
    findCachedClass(obj) {
        return this._cacheClass[obj];
    }
    getCached(obj) {
        let key = (typeof obj) == 'string' ? obj : this.classNameForType(obj);
        return this._modelCache[key];
    }
    filterCached(obj, id) {
        let key = (typeof obj) == 'string' ? obj : this.classNameForType(obj);
        if (this._modelCache[key] && typeof id == 'number')
            if (this._modelCacheHash[key]['_' + id])
                return [this._modelCacheHash[key]['_' + id]];
            else
                return [];
        else if (this._modelCache[key] && typeof id == 'function')
            return this._modelCache[key].filter(o => id(o));
        return null;
    }
    registeredClassForString(key) {
        return this._cacheClass[key];
    }
    sessionObservable(fire = false) {
        if (fire) {
            setTimeout(() => this._sessionSubject.next(this.localSession()), 10);
        }
        return this._sessionObservable;
    }
    onReady() {
        let ls = this.localSession();
        if (ls) {
            console.log('existsing');
            return (0, rxjs_1.of)(ls);
        }
        else if (this._loadingSession) {
            console.log('waitload');
            return this._loadingSession;
        }
        else {
            console.log('startload');
            return this.loginWithClientCredentials();
        }
    }
    localSession() {
        let key = this.clientKey();
        let sess = this.storage.get(key);
        if (sess) {
            // If session stored in local storage use it and cehck if it has expired
            if (sess['expires_by'] && sess['expires_by'] < new Date().getTime()) {
                this.token = null;
                this.storage.del(key);
                this._sessionSubject.next(null); // Notify session has been invalidated.             
                return null;
            }
            else {
                this.token = sess['access_token'];
                this.mediaToken = sess['media_token'];
                if (sess['user'])
                    sess['user'] = new this.UserModel(this).set(sess['user']);
                if (sess['device'])
                    sess['device'] = new device_1.Device(this).set(sess['device']);
                return sess;
            }
        }
        else {
            // If no session stored in local storage. return in memory session value
            return this._sessionSubject.value;
        }
    }
    invalidateSession() {
        let key = this.clientKey();
        this._sessionSubject.next(null);
        this.storage.del(key);
        this.invalidateCache();
    }
    invalidateCache() {
        this._modelCache = {};
        this._cacheClass = {};
        this._modelCacheHash = {};
    }
    authToken() {
        let key = this.clientKey();
        let sess = this.storage.get(key);
        if (!sess || (sess['expires_by'] && sess['expires_by'] < new Date().getTime())) {
            return null;
        }
        else {
            return sess['access_token'];
        }
    }
    saveLocalSession(obj) {
        this.token = obj['access_token'];
        this.mediaToken = obj['media_token'];
        // If persis flag is true save in local storage
        if (this._persistSession) {
            var ut = typeof obj['user'];
            var dt = typeof obj['device'];
            if (obj['user'] instanceof base_models_1.VasatModel)
                obj['user'] = obj['user'].toJSON();
            if (obj['device'] instanceof base_models_1.VasatModel)
                obj['device'] = obj['device'].toJSON();
            this.storage.set(this.clientKey(), obj);
        }
        // Trigger session observables when saving a new session
        this._sessionSubject.next(obj);
        this.localSession();
    }
    hasSession() {
        return !!this.localSession();
    }
    signup(username, password, email, userMeta, byoClientId) {
        let obj = {
            client_id: byoClientId ? byoClientId : this.config.clientId,
            grant_type: 'password',
            username: username,
            password: password,
            email: email,
            device: device_1.BrowserDeviceMeta.makeBrowserDevice()
        };
        if (userMeta)
            obj['user'] = userMeta;
        return this.post('/access/signup', obj, { withCredentials: true }).pipe((0, operators_1.map)((r) => {
            this.processV2Token(r);
        }));
    }
    signupWith2FA(username, pass, userMeta, mode = 'password') {
        let obj = {
            grant_type: mode,
            client_id: this.config.clientId,
            username: username,
        };
        if (userMeta)
            obj['user'] = userMeta;
        if (pass)
            obj['password'] = pass;
        return this.post('/access/2fa/signup/request', obj, { withCredentials: true });
    }
    check2FASignup(token) {
        return this.post('/access/2fa/signup/check', {
            token: token,
            client_id: this.config.clientId
        });
    }
    complete2FASignup(token, password, userMeta) {
        var obj = {
            token: token,
            client_id: this.config.clientId
        };
        if (password)
            obj['password'] = password;
        if (userMeta)
            obj['user'] = userMeta;
        return this.post('/access/2fa/signup/complete', obj).pipe((0, operators_1.map)(r => this.processV2Token(r)));
    }
    loginWithUsername(user, pass, persistSession = true, byoClientId) {
        this._persistSession = persistSession; // Doing this so we dont need to pass down the variable through all methods.
        return this._loadingSession = this.post('/access/login', {
            client_id: byoClientId ? byoClientId : this.config.clientId,
            grant_type: 'password',
            username: user,
            password: pass,
            device: device_1.BrowserDeviceMeta.makeBrowserDevice()
        }, { withCredentials: true }).pipe((0, operators_1.map)((r) => this.processV2Token(r)));
    }
    loginWithClientCredentials() {
        let curSess = this.localSession();
        if (curSess) {
            return (0, rxjs_1.of)(curSess).pipe((0, operators_1.map)((o) => {
                this._sessionSubject.next(o);
                return o;
            }));
        }
        if (!this._loadingSession) {
            this._loadingSession = this.post('/access/login', {
                client_id: this.config.clientId,
                grant_type: 'client_credentials',
                client_secret: this.config.clientSecret || '',
                device: device_1.BrowserDeviceMeta.makeBrowserDevice()
            }).pipe((0, operators_1.map)((r) => this.processV2Token(r)));
        }
        return this._loadingSession;
    }
    /*
    loginWithTokenResponse(resp:any):Observable<any>{
        this.processResp(resp)
        return this._loadingSession = new Device(this,{}).saveObservable().pipe(
            map((dev)=> {
                var ls = this.localSession()
                ls.device = dev
                this.saveLocalSession(ls)
            return dev
            }),
            flatMap((res) =>
                new MeUser(this,{id:'me'}).fetchObservable()
            ),
            map((user)=> {
                var ls = this.localSession()
                ls.user = user
                this.saveLocalSession(ls)
                this._loadingSession = null
                return user
            }),
            share()
       )
    }*/
    /**
     * Login using remote FacebookOauth
     * @param remoteClientId Facebook App ID
     * @param remoteClientToken Facebook access token given by the Facebook SDK.
     */
    loginWithClientFacebook(remoteClientId, remoteClientToken) {
        return this._loadingSession = this.post('/access/token', { client_id: this.config.clientId, grant_type: 'remote_client', remote_client_id: remoteClientId, remote_token: remoteClientToken }, { withCredentials: true }).pipe((0, operators_1.map)((r) => {
            this.processResp(r);
        }), (0, operators_1.concatMap)((res) => new device_1.Device(this, {}).saveObservable()), (0, operators_1.map)((dev) => {
            var ls = this.localSession();
            ls.device = dev;
            this.saveLocalSession(ls);
            return dev;
        }), (0, operators_1.concatMap)((res) => new user_1.MeUser(this, { id: 'me' }).fetchObservable()), (0, operators_1.map)((user) => {
            var ls = this.localSession();
            ls.user = user;
            this.saveLocalSession(ls);
            this._loadingSession = null;
            return user;
        }), (0, operators_1.share)());
    }
    loginWithClientTwitter(remoteClientId, remoteUserId, remoteToken, remoteSecret) {
        return this._loadingSession = this.post('/access/token', { client_id: this.config.clientId, grant_type: 'remote_client', remote_client_id: remoteClientId, remote_token: remoteUserId + "&" + remoteToken + "&" + remoteSecret }, { withCredentials: true }).pipe((0, operators_1.map)((r) => {
            this.processResp(r);
        }), (0, operators_1.concatMap)((res) => new device_1.Device(this, {}).saveObservable()), (0, operators_1.map)((dev) => {
            var ls = this.localSession();
            ls.device = dev;
            this.saveLocalSession(ls);
            return dev;
        }), (0, operators_1.concatMap)((res) => new user_1.MeUser(this, { id: 'me' }).fetchObservable()), (0, operators_1.map)((user) => {
            var ls = this.localSession();
            ls.user = user;
            this.saveLocalSession(ls);
            this._loadingSession = null;
            return user;
        }), (0, operators_1.share)());
    }
    registerPushRegId(regId) {
        var ls = this.localSession();
        //console.log("pushRegIdSent: " + ls.device.pushRegIdSent)
        // Only register push reg Id with server if we have a session with a device
        if (ls && ls.device && !ls.device.pushRegIdSent) {
            //console.log("Sending push reg id to server")
            ls.device.pushRegId = regId;
            ls.device.allowPush = true;
            return ls.device.saveObservable().pipe((0, operators_1.map)(res => {
                //console.log(res)
                ls.device.pushRegIdSent = true;
                this.saveLocalSession(ls);
            }));
        }
        else {
            //console.log("Device not found or Push reg Id already sent")
            return rxjs_1.EMPTY;
        }
    }
    resetPasswordRequest(email) {
        return this.post('/access/forget', { email: email }).pipe((0, operators_1.map)((r) => this.processResp(r)));
    }
    /**
     *
     * @deprecated Renamed to resetPasswordRequest()
     */
    requestForgetPassword(email) {
        return this.resetPasswordRequest(email);
    }
    resetPasswordTokenCheck(token) {
        return this.get('/access/forget/' + token).pipe((0, operators_1.map)((r) => this.processResp(r)));
    }
    resetPassword(token, newPassword) {
        return this.put('/access/forget/' + token, { newPassword: newPassword }).pipe((0, operators_1.map)((r) => this.processResp(r)));
    }
    /**
     *
     * @deprecated Renamed to logout()
     */
    logoutObservable() {
        return this.logout();
    }
    logout() {
        return this.get('/access/logout').pipe((0, operators_1.map)((r) => {
            let key = this.clientKey();
            this.token = null;
            this.invalidateSession();
            this.storage.del(key);
            this._logoutEvent.next("");
            return r;
        }));
    }
    refreshToken(err) {
        var ls = this.localSession();
        if (ls && ls.refresh_token && this._refreshing == null) {
            this._refreshing = new rxjs_1.Subject();
            this._refreshingObs = this._refreshing.asObservable();
            return this._http('post', '/access/login', {
                "grant_type": "refresh_token",
                "client_id": this.config.clientId,
                "refresh_token": ls.refresh_token
            }, null, true).pipe((0, operators_1.catchError)(e => {
                delete ls.refresh_token;
                this.invalidateSession();
                return (0, rxjs_1.throwError)(new types_1.VasatError({ status: 90011, message: 'Token failed and refresh token failed' }, e));
            }), (0, operators_1.map)(r => {
                var sess = this.processV2Token(r);
                this._refreshing.next(sess);
                this._refreshing.complete();
                this._refreshing = null;
                this._refreshingObs = null;
                return sess;
            }));
        }
        else if (this._refreshing) {
            return this._refreshingObs;
        }
        else {
            this.invalidateSession();
            return (0, rxjs_1.throwError)(new types_1.VasatError({ status: 90011, message: 'Token failed and refresh token not found' }, err));
        }
    }
    refreshMeUser() {
        return new user_1.MeUser(this)
            .fetch()
            .pipe((0, operators_1.map)((user) => {
            var ls = this.localSession();
            ls.user = user;
            this.saveLocalSession(ls);
            return user;
        }));
    }
    processResp(resp) {
        if (!resp.status) {
            resp = {
                status: resp['error'] ? 409 : 200,
                message: resp['error'] || 'ok',
                payload: resp
            };
        }
        if (resp.payload && resp.payload.access_token) {
            let obj = {
                access_token: resp.payload.access_token
            };
            if (resp.payload.expires_in && parseInt(resp.payload.expires_in)) {
                obj['expires_by'] = new Date(new Date().getTime() + 1000 * resp.payload.expires_in).getTime();
            }
            this.saveLocalSession(obj);
            this.localSession();
        }
        else if (resp.status < 400) {
            return resp;
        }
        else {
            this._sessionSubject.next(new types_1.VasatError(resp, null));
            throw resp;
        }
    }
    _getURL(url) {
        if (url.startsWith('http://') || url.startsWith('https://'))
            return url;
        else
            return this.config.host + url;
    }
    api(url, meth, args) {
        var a = new base_models_1.VasatAPICall();
        return a.apiObservable(this, meth || 'get', url, args);
    }
    get(url, args) {
        return this._http('get', url, null, args);
    }
    delete(url, args) {
        return this._http('delete', url, null, args);
    }
    put(url, obj, args) {
        return this._http('put', url, obj, args);
    }
    post(url, obj, args) {
        return this._http('post', url, obj, args);
    }
    _http(meth, url, obj, args, tryedRefresh = false) {
        let a = args || {};
        let reqOpt = {
            method: meth,
        };
        let headers = {};
        if (this.token)
            headers["Authorization"] = 'bearer ' + this.token;
        if (obj) {
            reqOpt.body = JSON.stringify(obj);
            headers["Content-Type"] = 'application/json';
        }
        reqOpt.headers = headers;
        return (0, rxjs_1.from)(fetch(this._getURL(url), reqOpt)).pipe((0, operators_1.concatMap)(res => {
            // Check for 400 and 500 server errors and throw exception accordingly
            if (res.status >= 400) {
                return (0, rxjs_1.from)(res.clone().json()).pipe((0, operators_1.concatMap)(response => {
                    // Trigger _errorEvent in case client app wants to do something special with errors. Specially with not Logged in responses
                    var error = new types_1.VasatError(response, "Error");
                    if ((response.status == 40014 || response.status == 40019 || response.status == 40022) && !tryedRefresh) {
                        return this.refreshToken(error).pipe((0, operators_1.concatMap)(_ => this._http(meth, url, obj, args, true)));
                    }
                    else {
                        this._errorEvent.next(error);
                        return (0, rxjs_1.throwError)(error);
                    }
                }));
            }
            else {
                // fetch request return custom response so we need to parse it to return vasat response
                return (0, rxjs_1.from)(res.clone().json());
            }
        }), (0, operators_1.catchError)(err => {
            // Gracefully handling fetch or other errors and convert them into VasatError
            let ve;
            if (err instanceof types_1.VasatError) {
                ve = err;
            }
            else if (err['status'] && err['message'] && err['version']) {
                ve = new types_1.VasatError(err, null);
            }
            else if (err instanceof TypeError) {
                ve = new types_1.VasatError({ status: 99001, message: "" + err, version: "", time: new Date().getTime() }, err);
            }
            else {
                ve = new types_1.VasatError({ status: 99002, message: "Unknown Error: " + err, version: "", time: new Date().getTime() }, err);
            }
            this._errorEvent.next(ve);
            throw ve;
        }));
    }
    file(url, meth, payload) {
        let reqOpt = {
            method: meth ? meth : "get",
        };
        let headers = {};
        if (this.token)
            headers["Authorization"] = 'bearer ' + this.token;
        if (payload) {
            reqOpt.body = JSON.stringify(payload);
            headers["Content-Type"] = 'application/json';
        }
        reqOpt.headers = headers;
        return (0, rxjs_1.from)(fetch(this._getURL(url), reqOpt)).pipe((0, operators_1.concatMap)(res => res.clone().blob()));
    }
    searchByObject(v) {
        return new base_models_1.VasatSearchQuery(v, this);
    }
    searchByObjectString(obj) {
        var cc = this._cacheClass[obj] || class VasatObj extends base_models_1.VasatModel {
            constructor(V) {
                super(V, obj);
            }
        };
        return this.searchByObject(cc);
    }
    searchByObjectStringAndDomain(obj, domain) {
        var key = domain ? domain + '/' + obj : obj;
        var cc = this._cacheClass[key] || class VasatObj extends base_models_1.VasatModel {
            constructor(V) {
                super(V, obj);
                this._domainName = domain;
            }
        };
        return this.searchByObject(cc);
    }
    /**
     * Generate a url to send the browser to so it can authenticate.
     * @client is the remote client uid
     * @redirectUrl is the url on your server to be sent to once the user has logged in (or not)
     *
     * returns observale of the url to be sent to
     */
    loginViaOAuthUrl(client, redirectUrl, state, scope) {
        let post = {
            clientId: this.config.clientId,
            redirectUrl: redirectUrl
        };
        if (scope)
            post['scope'] = scope;
        if (state)
            post['state'] = state;
        return this.api('/access/remote/' + client + '.url', 'post', post).pipe((0, operators_1.map)(r => r.message));
    }
    /**
     * When an oauth site returns you back to this site
     * @client is the remote client uid
     * @redirectUrl is the url on your server to be sent to once the user has logged in (or not)
     * @code is the code returned by the oauth server
     * returns observale of the url to be sent to
     */
    verifyOAuthUrl(client, code, redirectUrl, state) {
        let post = {
            clientId: this.config.clientId,
            redirectUrl: redirectUrl,
            accessCode: code,
            device: device_1.BrowserDeviceMeta.makeBrowserDevice()
        };
        if (state)
            post['state'] = state;
        return this.post('/access/remote/' + client + '.grant', post).pipe((0, operators_1.map)(r => this.processV2Token(r).user));
    }
    activeHostServices() {
        if (this.services.length)
            return (0, rxjs_1.of)(this.services);
        if (!this.servicesLoading) {
            var toLoad = [];
            var isAdmin = null;
            var isDB = null;
            this.servicesLoading = this.api("/vasat").pipe((0, operators_1.map)((res) => {
                this.services = res.services;
                if (this.services.find((c) => c.path == 'uppr'))
                    this.services.push({
                        name: "Clients",
                        path: "clients",
                        icon: null,
                        hidden: false,
                        submenu: [],
                        meta: null
                    });
                this.services = this.services.sort((a, b) => {
                    if (a.name < b.name)
                        return -1;
                    else if (a.name > b.name)
                        return 1;
                    else
                        return 0;
                });
                this.services.map((c) => {
                    c.submenu = [];
                    c.meta = {};
                    if (!c.icon) {
                        if (c.path == 'uppr') {
                            c.name = 'Manage Data';
                            c.icon = 'database';
                            toLoad.push(this.api('/vasat/uppr').pipe((0, operators_1.map)((res) => {
                                isAdmin = res;
                                c.meta = res;
                                return this.services;
                            })));
                        }
                        else if (c.path == 'clients') {
                            c.icon = "plug";
                            toLoad.push(this.searchByObjectString("Client").queryObservable().pipe((0, operators_1.concatMap)((res) => {
                                c.meta = res.items;
                                c.submenu = res.items.map((i) => {
                                    return {
                                        path: "" + i.id,
                                        name: i.name
                                    };
                                });
                                return this.searchByObjectString("ClientRemoteServer").queryObservable();
                            }), (0, operators_1.map)((rc) => {
                                c.remotes = rc.items;
                                c.submenu2 = rc.items.map((i) => {
                                    return {
                                        path: "" + i.id,
                                        name: i.name
                                    };
                                });
                                return this.services;
                            })));
                        }
                        else if (c.path == 'push') {
                            c.name = 'Push Messages';
                            c.icon = 'comment';
                        }
                        else if (c.path == 'dba') {
                            c.icon = 'database';
                            c.hidden = true;
                            toLoad.push(this.api('/vasat/dba/initDB').pipe((0, operators_1.map)((res) => {
                                isDB = res;
                                c.meta = res;
                                return this.services;
                            })));
                        }
                        else if (c.path == 'user') {
                            c.hidden = true;
                        }
                        else if (c.path == 'gbbo') {
                            c.icon = 'birthday-cake';
                            c.submenu = [{
                                    path: "entry",
                                    name: "Join Entries"
                                }];
                        }
                        else {
                            c.icon = 'question-circle';
                        }
                    }
                });
                if (isAdmin) {
                    this.services.push({
                        name: 'Configure Clients',
                        path: 'clients',
                        icon: 'plug',
                        hidden: false,
                        submenu: [],
                        meta: {}
                    });
                }
                this.services.unshift({
                    name: 'Home',
                    path: 'home',
                    icon: 'home',
                    hidden: false,
                    submenu: [],
                    meta: {}
                });
                return toLoad;
            }), (0, operators_1.concatMap)((r) => {
                if (r.length) {
                    return (0, rxjs_1.forkJoin)(r);
                }
                else {
                    return (0, rxjs_1.of)([this.services]);
                }
            }), (0, operators_1.map)((r) => {
                if (isAdmin) {
                    const upprItem = this.services.find((c) => c.path == 'uppr');
                    const dbI = this.services.find((c) => c.path == 'dba');
                    upprItem.submenu = isAdmin.map((ccc) => {
                        var i = {
                            name: ccc.id,
                            path: ccc.id
                        };
                        if (isDB) {
                            i.meta = dbI.meta.find((d) => d.name == ccc.id);
                        }
                        return i;
                    }).sort((a, b) => {
                        if (a.name < b.name)
                            return -1;
                        else if (a.name > b.name)
                            return 1;
                        else
                            return 0;
                    });
                }
                return r[0];
            }));
        }
        return this.servicesLoading;
    }
    setDeviceMeta(dm) {
        this._defaultDeviceMeta = dm;
    }
    deviceMeta() {
        return this._defaultDeviceMeta.getMeta();
    }
    _loadSiteInfo(siteNfo) {
        // If we have a VasatSiteInfo in memory return it, otherwise query the server
        var basePath = siteNfo ? siteNfo.baseURL : '';
        return this.get(basePath + "/site/info").pipe((0, operators_1.map)(res => {
            res.payload.version = res.version;
            return res.payload;
        }), (0, operators_1.concatMap)(nfo => {
            if (!nfo.services.length)
                return (0, rxjs_1.of)(nfo);
            return (0, rxjs_1.forkJoin)(nfo.services.filter(a => a.path != undefined).map(a => this.api(basePath + (a.path.length ? '/' : '') + a.path + "/api/Models").pipe((0, operators_1.catchError)(a => (0, rxjs_1.of)({})))))
                .pipe((0, operators_1.map)(res => {
                // register the base path for all the objects used by this site & service combo
                nfo.services.filter(a => a.path != undefined).forEach((r, i) => {
                    if (res[i].results) {
                        r.models = res[i].results.map(r => {
                            var v = r.item || r;
                            v.id = r.id;
                            v.domain = siteNfo ? siteNfo.id : null;
                            return v;
                        }); //inline or under iten:{} node
                        r.models.forEach(m => {
                            var path = '/' + r.path + '/api';
                            if (path.startsWith('//'))
                                path = path.substring(1);
                            if (siteNfo)
                                this._modelPrefixes[siteNfo.id + '/' + m.id] = basePath + path;
                            else
                                this._modelPrefixes[m.id] = basePath + path;
                        });
                    }
                });
                return nfo;
            }));
        }), (0, operators_1.concatMap)(nfo => {
            var _a;
            if ((_a = nfo.remoteSites) === null || _a === void 0 ? void 0 : _a.length) {
                return (0, rxjs_1.forkJoin)(nfo.remoteSites.map(s => this._loadSiteInfo(s).pipe((0, operators_1.catchError)(e => {
                    return (0, rxjs_1.of)({
                        initialised: false,
                        site: s,
                        services: [],
                        error: e
                    });
                }), (0, operators_1.tap)(ss => {
                    ss.site.baseURL = s.baseURL;
                })))).pipe((0, operators_1.map)(r => {
                    nfo.remoteServiceInfo = r;
                    return nfo;
                }));
            }
            else {
                return (0, rxjs_1.of)(nfo);
            }
        }));
    }
    siteInfo(force = false, nest = true) {
        // If we have a VasatSiteInfo in memory return it, otherwise query the server
        if (this._siteInfo && !force) {
            return (0, rxjs_1.of)(this._siteInfo);
        }
        else {
            return this._loadSiteInfo().pipe((0, operators_1.tap)(nfo => this._siteInfo = nfo));
        }
        /**** TODO: uncomment this when site/info returns app and vasat version numbers
        // If we have a VasatSiteInfo in memory return it, otherwise query the server
        if (this._siteInfo) {
            return of(this._siteInfo)
        } else {
            return this.api("/site/info").pipe(
                map(res => {
                    // Store it in memory
                    this._siteInfo = res
                    return this._siteInfo
                })
            )
        }
        */
    }
    remoteLoginInfo() {
        if (this._remoteInfo)
            return (0, rxjs_1.of)(this._remoteInfo);
        else
            return this.get('/access/remote/' + this.config.clientId + '.remotes').pipe((0, operators_1.map)(r => r.payload));
    }
    /**
     * Returns the current VasatSiteInfo in memory. Will return null if not initialised.
     */
    getSiteInfo() {
        return this._siteInfo;
    }
    initSite(params) {
        return this.api("/site/init", "post", params).pipe((0, operators_1.map)(res => {
            // Store it in memory
            this._siteInfo = res;
            return this._siteInfo;
        }));
    }
    apiModels() {
        return this.api("/api/Models");
    }
    apiAccessModels() {
        return this.api("/access/api/Models");
    }
    getOpenApiUrl(path) {
        return this.config.host + "/docs/" + path + "openapi.json";
    }
    loginWith2FA(username, password) {
        return this.post('/access/2fa/login/request', { client_id: this.config.clientId, grant_type: 'password', username: username, password: password });
    }
    loginWithMagic(username) {
        return this.post('/access/2fa/login/request', { client_id: this.config.clientId, grant_type: 'magic', username: username });
    }
    complete2FALogin(token) {
        return this.post('/access/2fa/login/complete', {
            client_id: this.config.clientId,
            token: token,
            device: device_1.BrowserDeviceMeta.makeBrowserDevice()
        }).pipe((0, operators_1.map)(a => this.processV2Token(a)));
    }
    processV2Token(resp) {
        if ((resp === null || resp === void 0 ? void 0 : resp.payload) && resp.payload.access_token) {
            let obj = {
                access_token: resp.payload.access_token,
                refresh_token: resp.payload.refresh_token,
                media_token: resp.payload.media_token
            };
            if (resp.payload.expires_in && parseInt(resp.payload.expires_in)) {
                obj['expires_in'] = new Date(new Date().getTime() + 1000 * resp.payload.expires_in).getTime();
            }
            if (resp.payload.user)
                obj['user'] = new this.UserModel(this).set(resp.payload.user).set({ id: 'me' });
            this.saveLocalSession(obj);
            let ses = this.localSession();
            if (this.config.debug)
                console.log("Vasat Session:", ses);
            return ses;
        }
        else {
            var e = new types_1.VasatError(resp, null);
            this._sessionSubject.next(e);
            throw e;
        }
    }
}
exports.Vasat = Vasat;
